export default __webpack_public_path__ + "static/media/ODD_BG.ec4f2533.png";